<div ngbDropdown class="vox-dropdown-input">
  <button type="button" id="dropdownBasic3"
    ngbDropdownToggle>{{selectedModel}}</button>
  <div ngbDropdownMenu aria-labelledby="dropdownBasic3">
    <button type="button" ngbDropdownItem *ngFor="let model of models"
      (click)="selectModel(model)">{{model}}</button>
  </div>
</div>